import { render, staticRenderFns } from "./ContextMenuItem.vue?vue&type=template&id=7b9ebbda&scoped=true&"
import script from "./ContextMenuItem.vue?vue&type=script&lang=js&"
export * from "./ContextMenuItem.vue?vue&type=script&lang=js&"
import style0 from "./ContextMenuItem.vue?vue&type=style&index=0&id=7b9ebbda&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b9ebbda",
  null
  
)

export default component.exports